/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { Button, Tooltip } from "@duxton-web/ui"
import { DocumentOutlined } from "@duxton-web/icons"
import STORYBOOK_DEPLOYMENT_URL from "@storybook-constant"
import { useTranslation } from "common/utils/i18n"

function StorybookActionButton(): JSX.Element {
  const handleOnClick = () => {
    window.open(STORYBOOK_DEPLOYMENT_URL, "_blank")
  }

  return (
    <div
      css={css({ position: "fixed", bottom: "32px", right: "32px", zIndex: 2 })}
      data-testid="storybook-action-button"
    >
      <Tooltip
        title={useTranslation("storybookActionButtonTooltip")}
        placement="topRight"
      >
        <Button
          shape="circle"
          type="primary"
          size="large"
          onClick={handleOnClick}
          icon={<DocumentOutlined data-testid="documentation-icon" />}
        />
      </Tooltip>
    </div>
  )
}

export default StorybookActionButton
